import logUpload from './logUpload';
import logStorage from './logStorage';

export interface IStatisticsInfo extends Record<string, any> {
  pageLogType?: string;
  moduleMark?: string;
  clearModuleMarkAfterCallback?: boolean;
}

/**
 * uplodaLog
 */
export function uploadPageLogData(
  page?: string,
  pageLogType?: string,
  data?: IStatisticsInfo,
) {
  try {
    if (!page || !pageLogType) {
      console.warn('请提供页面标识与事件标识');
      return;
    }
    const statistics_name = `page_${page}__${pageLogType}`;
    const { pageInfo } = logStorage;
    const eventInfo = logStorage.getPageCabinet(pageLogType);

    logUpload({
      ...pageInfo,
      ...eventInfo,
      ...(data || {}),
      statistics_name,
      page,
      pageLogType,
    });
  } catch {
    // do nothing
  }
}

export function logTrack(pageLogType: string, data?: IStatisticsInfo) {
  const { pageName } = logStorage.pageInfo;
  if (!pageName) {
    console.warn('调用logTrack前，请调用useLogPageLoad初始化页面名称');
  }
  uploadPageLogData(pageName as string, pageLogType, data || {});
}
